import { getIn, useFormikContext } from "formik";
import { AlertCircle } from "lucide-react";
import { hasErrors } from "../utils/formik.util";

// Classes aplicadas ao controle quando o campo tem erro de validação (padrão para todos os campos)
export const FIELD_ERROR_CLASS = "border-destructive focus-visible:ring-destructive focus:ring-destructive";

export const useFieldError = (name: string): string | undefined => {
  const formikProps = useFormikContext<any>();
  return hasErrors(name, formikProps) ? getIn(formikProps.errors, name) : undefined;
};

export const FieldErrorMessage = ({ message }: { message?: string }) =>
  message ? (
    <p role="alert" className="mt-1.5 flex items-center gap-1 text-xs font-medium text-destructive">
      <AlertCircle aria-hidden className="h-3.5 w-3.5 shrink-0" />
      {message}
    </p>
  ) : null;

export const FieldError = ({ name }: { name: string }) => <FieldErrorMessage message={useFieldError(name)} />;
